var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2337 4.27022C10.0844 4.03789 10.1517 3.72855 10.3841 3.57929C10.6164 3.43003 10.9257 3.49737 11.075 3.72969L10.2337 4.27022ZM12.36 5.72974C12.5092 5.96206 12.4419 6.2714 12.2096 6.42066C11.9772 6.56993 11.6679 6.50259 11.5186 6.27026L12.36 5.72974ZM11.5186 5.72969C11.6679 5.49737 11.9772 5.43003 12.2095 5.57929C12.4419 5.72855 12.5092 6.03789 12.3599 6.27022L11.5186 5.72969ZM11.075 8.27026C10.9257 8.50259 10.6164 8.56993 10.384 8.42066C10.1517 8.2714 10.0844 7.96206 10.2336 7.72974L11.075 8.27026ZM11.9395 5.49999C12.2156 5.49999 12.4395 5.72385 12.4395 5.99999C12.4395 6.27613 12.2156 6.49999 11.9395 6.49999V5.49999ZM5.97278 6.49999C5.69664 6.49999 5.47278 6.27613 5.47278 5.99999C5.47278 5.72385 5.69664 5.49999 5.97278 5.49999V6.49999ZM11.075 3.72969L12.36 5.72974L11.5186 6.27026L10.2337 4.27022L11.075 3.72969ZM12.3599 6.27022L11.075 8.27026L10.2336 7.72974L11.5186 5.72969L12.3599 6.27022ZM11.9395 6.49999L5.97278 6.49999V5.49999L11.9395 5.49999V6.49999Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96167 8.14286C7.96167 9.72081 6.92271 11 5.64109 11H3.3205C2.03888 11 0.999922 9.72081 0.999922 8.14286V3.85714C0.999922 2.27919 2.03888 1 3.3205 1H5.64109C6.92271 1 7.96167 2.27919 7.96167 3.85714",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutWhite);
export default __webpack_public_path__ + "static/media/logout-white.fac4383a5f4d014b7274364088fc871e.svg";
export { ForwardRef as ReactComponent };